/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProjectClientInputsQueryVariables = Types.Exact<{
  ownerId: Types.Scalars['ID']['input'];
}>;


export type ProjectClientInputsQuery = { clientInputs: { __typename: 'ClientInputsResult', clientInputs: Array<{ __typename: 'ClientInput', id: string, source: Types.ClientInputSource, commentText?: string | null, createdAt: any, attachments: Array<{ __typename: 'ClientInputAttachment', attachmentId: string, position: number, url: string, title: string, mimeType: string }> }> } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };

export type ProjectClientInputsBox__ClientInputFragment = { __typename: 'ClientInput', id: string, source: Types.ClientInputSource, commentText?: string | null, createdAt: any, attachments: Array<{ __typename: 'ClientInputAttachment', attachmentId: string, position: number, url: string, title: string, mimeType: string }> };

export const ProjectClientInputsBox__ClientInputFragmentDoc = gql`
    fragment ProjectClientInputsBox__ClientInput on ClientInput {
  id
  source
  commentText
  createdAt
  attachments {
    attachmentId
    position
    url
    title
    mimeType
  }
}
    `;
export const ProjectClientInputsDocument = gql`
    query ProjectClientInputs($ownerId: ID!) {
  clientInputs(ownerType: PROJECT, ownerId: $ownerId) {
    ... on ClientInputsResult {
      clientInputs {
        ...ProjectClientInputsBox__ClientInput
      }
    }
  }
}
    ${ProjectClientInputsBox__ClientInputFragmentDoc}`;

/**
 * __useProjectClientInputsQuery__
 *
 * To run a query within a React component, call `useProjectClientInputsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectClientInputsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectClientInputsQuery({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *   },
 * });
 */
export function useProjectClientInputsQuery(baseOptions: Apollo.QueryHookOptions<ProjectClientInputsQuery, ProjectClientInputsQueryVariables> & ({ variables: ProjectClientInputsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectClientInputsQuery, ProjectClientInputsQueryVariables>(ProjectClientInputsDocument, options);
      }
export function useProjectClientInputsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectClientInputsQuery, ProjectClientInputsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectClientInputsQuery, ProjectClientInputsQueryVariables>(ProjectClientInputsDocument, options);
        }
export function useProjectClientInputsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectClientInputsQuery, ProjectClientInputsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectClientInputsQuery, ProjectClientInputsQueryVariables>(ProjectClientInputsDocument, options);
        }
export type ProjectClientInputsQueryHookResult = ReturnType<typeof useProjectClientInputsQuery>;
export type ProjectClientInputsLazyQueryHookResult = ReturnType<typeof useProjectClientInputsLazyQuery>;
export type ProjectClientInputsSuspenseQueryHookResult = ReturnType<typeof useProjectClientInputsSuspenseQuery>;
export type ProjectClientInputsQueryResult = Apollo.QueryResult<ProjectClientInputsQuery, ProjectClientInputsQueryVariables>;